import React, { useRef, useState } from 'react';
import { View, ScrollView } from 'react-native';
import i18n from 'i18n-js';
import LinearGradient from 'react-native-linear-gradient';
import { connect } from 'react-redux';

import { firstLetterUp, NCFileLevels } from '@helpers';
import { scale } from '@components/frame';

import ColorWrapper from '@styles/colors';
import Selector from '@styles/selectors';
import { font } from '@styles/fonts';

const tabs = [{ value: NCFileLevels.GENERAL }, { value: NCFileLevels.TIMES }];

const TimeLine = ({ selectedNCFileLevel, setSelectedNCFileLevel, blur = false, C, colors: { light, dark } }) => {
  const scrollView = useRef(null);

  const [x, setX] = useState(0);

  const refsElements = { [NCFileLevels.GENERAL]: useRef(null), [NCFileLevels.TIMES]: useRef(null) };

  const base = C.scheme === 'light' ? `${light},` : `${dark},`;

  return (
    <View style={{ position: 'relative', justifyContent: 'center', marginBottom: scale(15) }}>
      {blur && (
        <LinearGradient
          colors={[`rgba(${base} 0)`, `rgba(${base} 0.9)`, `rgba(${base} 1)`]}
          locations={[0, 0.87, 1]}
          style={{
            position: 'absolute',
            width: scale(7),
            left: 0,
            zIndex: 100,
            height: scale(33),
          }}
          start={{ x: 1, y: 0 }}
          end={{ x: 0, y: 0 }}
        />
      )}
      {blur && (
        <LinearGradient
          colors={[`rgba(${base} 0)`, `rgba(${base} 0.9)`, `rgba(${base} 1)`]}
          locations={[0, 0.87, 1]}
          style={{
            position: 'absolute',
            width: scale(7),
            right: 0,
            zIndex: 100,
            height: scale(33),
          }}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }}
        />
      )}
      <ScrollView
        horizontal={true}
        showsHorizontalScrollIndicator={false}
        scrollEnabled={blur}
        ref={scrollView}
        onContentSizeChange={() => scrollView?.current?.scrollToEnd({ animated: false })}
        contentContainerStyle={{
          justifyContent: 'center',
          alignItems: 'center',
          minWidth: '100%',
          gap: scale(6),
          paddingHorizontal: scale(20),
        }}
        scrollEventThrottle={16}
        onScroll={(e) => {
          setX(e.nativeEvent.contentOffset.x);
        }}
      >
        {tabs.map((item) => (
          <View ref={refsElements[item.value]} key={item.value}>
            <Selector
              {...{
                scale,
                font,
                selected: selectedNCFileLevel === item.value,
                variant: 'L',
                text: firstLetterUp(i18n.t(item.value)),
                onPress: () => {
                  setSelectedNCFileLevel(item.value);
                  refsElements[item.value]?.current?.measure((fx, fy, width, height, px, py) => {
                    if (px < scale(30)) {
                      scrollView?.current?.scrollTo({ animated: true, x: x - (Math.abs(px) + scale(30)) });
                      return;
                    }
                    scrollView?.current?.measure((fx, fy, scrollWidth) => {
                      if (px + width + scale(30) > scrollWidth) {
                        const offset = px + width - scrollWidth + x;
                        scrollView?.current?.scrollTo({ animated: true, x: offset + scale(30) });
                      }
                    });
                  });
                },
              }}
            />
          </View>
        ))}
      </ScrollView>
    </View>
  );
};

export default connect(({ user: { featureFlags } }) => ({ featureFlags }), {})(ColorWrapper(TimeLine));
